export default "assets/images/icons/select-arrow-b103c636.svg";